import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, capitalize, Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// hooks
import useAuth from '../../../hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import MyAvatar from '../../../components/MyAvatar';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

type Props = {
  isCollapse: boolean | undefined;
};

export default function NavbarAccount({ isCollapse }: Props) {
  const { user, role } = useAuth();

  const userData = user?.userData ?? {};
  const { firstName = 'View Profile' } = userData;

  return (
    <RootStyle
      sx={{
        ...(isCollapse && {
          bgcolor: 'transparent',
        }),
      }}
    >
      <MyAvatar />
      <Box
        sx={{
          ml: 2,
          transition: (theme) =>
            theme.transitions.create('width', {
              duration: theme.transitions.duration.shorter,
            }),
          ...(isCollapse && {
            ml: 0,
            width: 0,
          }),
        }}
      >
        {!isCollapse && <Typography variant='subtitle2'>{firstName}</Typography>}
        <Typography variant='body2' noWrap sx={{ color: 'text.secondary' }}>
          {capitalize(role)}
        </Typography>
      </Box>
    </RootStyle>
  );
}
